import useStorage from './useStorage';

export default useStorage;
